export default "__VITE_ASSET__DrGqMboL__"